// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Calendar__calendar-b0e740 {
  min-height: 360px;
}

.Calendar__calendar-b0e740 .react-calendar__navigation {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 21px;
}

.Calendar__calendar-b0e740 .react-calendar__navigation__label {
  flex: none !important;
  height: 32px;
  padding: 0px 12px;
  font: var(--font-body-1);
  letter-spacing: var(--font-spacing-body-1);
  color: var(--base-110);
}

.Calendar__calendar-b0e740 .react-calendar__navigation__arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 33px;
  height: 32px;
  border-radius: 16px;
  cursor: pointer;
}

.Calendar__calendar-b0e740 .react-calendar__navigation__arrow:hover,
.Calendar__calendar-b0e740 .react-calendar__navigation__arrow:focus {
  background-color: var(--base-20);
}

.Calendar__calendar-b0e740 .react-calendar__navigation__arrow:active {
  background-color: var(--base-30);
}

.Calendar__calendar-b0e740 .react-calendar__navigation__arrow:disabled {
  background-color: transparent;
  cursor: default;
}

.Calendar__calendar-b0e740 .react-calendar__navigation__arrow svg > * {
  fill: var(--base-80);
}

.Calendar__calendar-b0e740 .react-calendar__navigation__arrow:disabled svg > * {
  fill: var(--base-40);
}

.Calendar__calendar-b0e740 .react-calendar__month-view__weekdays {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
}

.Calendar__calendar-b0e740 .react-calendar__month-view__days {
  display: flex;
  flex-direction: row;
  margin: 0px 0px -8px calc((100% - 280px) / -7);
}

.Calendar__calendar-b0e740 .react-calendar__month-view__weekdays__weekday,
.Calendar__calendar-b0e740 .react-calendar__tile {
  flex: none !important;
  width: 40px;
  margin-bottom: 8px;
  text-align: center;
}

.Calendar__calendar-b0e740 .react-calendar__tile {
  height: 40px;
  margin-inline-start: calc((100% - 280px) / 7);
  border-radius: 24px;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-110);
  cursor: pointer;
}

.Calendar__calendar-b0e740 .react-calendar__tile:hover,
.Calendar__calendar-b0e740 .react-calendar__tile:focus {
  background-color: var(--base-30);
}

.Calendar__calendar-b0e740 .react-calendar__tile.react-calendar__month-view__days__day--neighboringMonth {
  color: var(--base-80);
}

.Calendar__calendar-b0e740 .react-calendar__tile:disabled {
  border: none;
  background-color: transparent;
  color: var(--base-50);
  cursor: default;
}

.Calendar__calendar-b0e740 .react-calendar__tile.react-calendar__tile--now {
  border: 1px solid var(--brand-primary-40);
  color: var(--brand-primary-40);
}

.Calendar__calendar-b0e740 .react-calendar__tile:active:not(:disabled),
.Calendar__calendar-b0e740 .react-calendar__tile.react-calendar__tile--active {
  border: none;
  background-color: var(--brand-primary-40);
  color: var(--addition-50);
}

.Calendar__calendar-b0e740 .react-calendar__month-view__weekdays__weekday abbr,
.Calendar__calendar-b0e740 .react-calendar__tile abbr {
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Calendar/Calendar.styles.m.css"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;;EAEE,gCAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,6BAAA;EACA,eAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,4BAAA;EACA,8CAAA;EACA,qBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8CAAA;AACF;;AAEA;;EAEE,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,6CAAA;EACA,mBAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,eAAA;AACF;;AAEA;;EAEE,gCAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,eAAA;AACF;;AAEA;EACE,yCAAA;EACA,8BAAA;AACF;;AAEA;;EAEE,YAAA;EACA,yCAAA;EACA,yBAAA;AACF;;AAEA;;EAEE,qBAAA;AACF","sourcesContent":[".calendar {\n  min-height: 360px;\n}\n\n.calendar :global(.react-calendar__navigation) {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-bottom: 21px;\n}\n\n.calendar :global(.react-calendar__navigation__label) {\n  flex: none !important;\n  height: 32px;\n  padding: 0px 12px;\n  font: var(--font-body-1);\n  letter-spacing: var(--font-spacing-body-1);\n  color: var(--base-110);\n}\n\n.calendar :global(.react-calendar__navigation__arrow) {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 33px;\n  height: 32px;\n  border-radius: 16px;\n  cursor: pointer;\n}\n\n.calendar :global(.react-calendar__navigation__arrow:hover),\n.calendar :global(.react-calendar__navigation__arrow:focus) {\n  background-color: var(--base-20);\n}\n\n.calendar :global(.react-calendar__navigation__arrow:active) {\n  background-color: var(--base-30);\n}\n\n.calendar :global(.react-calendar__navigation__arrow:disabled) {\n  background-color: transparent;\n  cursor: default;\n}\n\n.calendar :global(.react-calendar__navigation__arrow svg > *) {\n  fill: var(--base-80);\n}\n\n.calendar :global(.react-calendar__navigation__arrow:disabled svg > *) {\n  fill: var(--base-40);\n}\n\n.calendar :global(.react-calendar__month-view__weekdays) {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n}\n\n.calendar :global(.react-calendar__month-view__days) {\n  display: flex;\n  flex-direction: row;\n  margin: 0px 0px -8px calc((100% - 40px * 7) / -7);\n}\n\n.calendar :global(.react-calendar__month-view__weekdays__weekday),\n.calendar :global(.react-calendar__tile) {\n  flex: none !important;\n  width: 40px;\n  margin-bottom: 8px;\n  text-align: center;\n}\n\n.calendar :global(.react-calendar__tile) {\n  height: 40px;\n  margin-inline-start: calc((100% - 40px * 7) / 7);\n  border-radius: 24px;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-110);\n  cursor: pointer;\n}\n\n.calendar :global(.react-calendar__tile:hover),\n.calendar :global(.react-calendar__tile:focus) {\n  background-color: var(--base-30);\n}\n\n.calendar :global(.react-calendar__tile.react-calendar__month-view__days__day--neighboringMonth) {\n  color: var(--base-80);\n}\n\n.calendar :global(.react-calendar__tile:disabled) {\n  border: none;\n  background-color: transparent;\n  color: var(--base-50);\n  cursor: default;\n}\n\n.calendar :global(.react-calendar__tile.react-calendar__tile--now) {\n  border: 1px solid var(--brand-primary-40);\n  color: var(--brand-primary-40);\n}\n\n.calendar :global(.react-calendar__tile:active:not(:disabled)),\n.calendar :global(.react-calendar__tile.react-calendar__tile--active) {\n  border: none;\n  background-color: var(--brand-primary-40);\n  color: var(--addition-50);\n}\n\n.calendar :global(.react-calendar__month-view__weekdays__weekday abbr),\n.calendar :global(.react-calendar__tile abbr) {\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"calendar": `Calendar__calendar-b0e740`,
	"react-calendar__navigation": `react-calendar__navigation`,
	"reactCalendarNavigation": `react-calendar__navigation`,
	"react-calendar__navigation__label": `react-calendar__navigation__label`,
	"reactCalendarNavigationLabel": `react-calendar__navigation__label`,
	"react-calendar__navigation__arrow": `react-calendar__navigation__arrow`,
	"reactCalendarNavigationArrow": `react-calendar__navigation__arrow`,
	"react-calendar__month-view__weekdays": `react-calendar__month-view__weekdays`,
	"reactCalendarMonthViewWeekdays": `react-calendar__month-view__weekdays`,
	"react-calendar__month-view__days": `react-calendar__month-view__days`,
	"reactCalendarMonthViewDays": `react-calendar__month-view__days`,
	"react-calendar__month-view__weekdays__weekday": `react-calendar__month-view__weekdays__weekday`,
	"reactCalendarMonthViewWeekdaysWeekday": `react-calendar__month-view__weekdays__weekday`,
	"react-calendar__tile": `react-calendar__tile`,
	"reactCalendarTile": `react-calendar__tile`,
	"react-calendar__month-view__days__day--neighboringMonth": `react-calendar__month-view__days__day--neighboringMonth`,
	"reactCalendarMonthViewDaysDayNeighboringMonth": `react-calendar__month-view__days__day--neighboringMonth`,
	"react-calendar__tile--now": `react-calendar__tile--now`,
	"reactCalendarTileNow": `react-calendar__tile--now`,
	"react-calendar__tile--active": `react-calendar__tile--active`,
	"reactCalendarTileActive": `react-calendar__tile--active`
};
module.exports = ___CSS_LOADER_EXPORT___;
